import { render, staticRenderFns } from "./overview_pc.vue?vue&type=template&id=201a05a9&scoped=true&"
import script from "./overview_pc.vue?vue&type=script&lang=js&"
export * from "./overview_pc.vue?vue&type=script&lang=js&"
import style0 from "./overview_pc.vue?vue&type=style&index=0&id=201a05a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a05a9",
  null
  
)

export default component.exports